import React from 'react'
import AppDialogWrapper from './AppDialogWrapper'
import AppDialogHeader from './AppDialogHeader'
import AppDialogContent from './AppDialogContentWrapper'
import AppDialogActions from './AppDialogActions'
import { AppDialogProps } from './types'

export default function AppDialog({
    allowEsc = true,
    allowBackdropClick = true,
    scrollBehavior = 'body',
    title,
    onClose,
    headerClose,
    children,
    actions,
    headerProps,
    contentProps,
    topAlign,
    paperSx,
    ...rest
}: AppDialogProps) {
    const handleWrapperClose = (
        event: object | undefined,
        reason: 'backdropClick' | 'escapeKeyDown'
    ) => {
        if (reason === 'backdropClick' && !allowBackdropClick) return
        if (reason === 'escapeKeyDown' && !allowEsc) return
        onClose?.(event, reason)
    }

    return (
        <AppDialogWrapper
            onClose={(event, reason) => handleWrapperClose(event, reason)}
            scroll={scrollBehavior}
            topAlign={topAlign}
            paperSx={paperSx}
            {...rest}
        >
            {title && (
                <AppDialogHeader
                    title={title}
                    onClose={
                        headerClose
                            ? (event) => headerClose(event, 'escapeKeyDown')
                            : undefined
                    }
                    {...headerProps}
                />
            )}

            <AppDialogContent {...contentProps}>{children}</AppDialogContent>

            {actions && <AppDialogActions>{actions}</AppDialogActions>}
        </AppDialogWrapper>
    )
}
